const BEFORE = 0;
const RUNNING = 1;
const AFTER = 2;

export default {
    BEFORE,
    RUNNING,
    AFTER,
};